import React from "react";
import { ReactComponent as CheckIcon } from "assets/img/svg/CheckIcon.svg";

const LinkTxnCanceled = () => {
  return (
    <div
      className=" d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "212px" }}
    >
      <span
        className=" d-flex align-items-center justify-content-center"
        style={{
          backgroundColor: "#05945B",
          border: "1px",
          borderRadius: "50%",
          width: "56px",
          height: "56px",
        }}
      >
        <CheckIcon />
      </span>

      <div className="mt-2 dark-text label-color">
        Payment link successfully cancelled
      </div>
    </div>
  );
};
export default LinkTxnCanceled;
